import { render, staticRenderFns } from "./preview-appendix.vue?vue&type=template&id=15bf6bc4&scoped=true"
import script from "./preview-appendix.vue?vue&type=script&lang=js"
export * from "./preview-appendix.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=15bf6bc4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf6bc4",
  null
  
)

export default component.exports